import React, { useMemo } from "react";
import { useWorkspacesList } from "@api/workspace.api";
import { useScope } from "@state/scopeContext.lib";

interface Props {
    clientIds: string[] | undefined;
}

export const ClientIdsFilterLabel: React.FC<Props> = ({ clientIds }) => {
    const { organizationId } = useScope();
    const { data: clients = [] } = useWorkspacesList(
        organizationId ? { organizationId } : undefined,
        { enabled: !!organizationId },
    );

    const selectedNames = useMemo(
        () =>
            clients.filter((c) => clientIds?.includes(c.id)).map((c) => c.name),
        [clients, clientIds],
    );

    if (selectedNames.length === 0) {
        return null;
    }

    if (selectedNames.length === 1) {
        return <span>{selectedNames[0]}</span>;
    }

    return <span>{selectedNames.length} clients</span>;
};
